module.exports = __webpack_public_path__ + "img/bg-fail.2a4229e7.png";